import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface DialogState {
  isOpen: boolean;
  title: string;
  content: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
}

const initialState: DialogState = {
  isOpen: false,
  title: '',
  content: '',
};

export const dialogSlice = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    openDialog: (_, action: PayloadAction<Omit<DialogState, 'isOpen'>>) => {
      return { ...action.payload, isOpen: true };
    },
    closeDialog: () => initialState,
  },
});

export const { openDialog, closeDialog } = dialogSlice.actions;
export default dialogSlice.reducer;
